export enum SettlementType {
  Online = 'ONLINE',
  File = 'FILE',
}
